import { Button, toast } from '@fareye/ui'
import { cancelToken, del } from '@fareye/utils'
import React, { useState } from 'react'
import { POI_CONFIG } from '../../../config/constants'

export default function DeletePoi({selectedPoi}:any) {
    const {poiConfig} = POI_CONFIG
    const [loading,setLoading]=useState(false)
    const source=cancelToken().source()
    const handleDeleteAction= async()=>{
        try {
            setLoading(true)
            const url= `${poiConfig}/${selectedPoi.id}`
            const {data} =await del(url,source.token)
            toast.success("Poi config deleted successfully")
            setLoading(false)

        } catch (error) {
            setLoading(false)
            toast.error("Something went wrong...")
            
        }
    }

  return (
    <Button variant='s danger' isLoading={loading} onClick={handleDeleteAction}>Delete</Button>
  )
}
